import { render } from "./KeytRename.vue?vue&type=template&id=7b671a18"
import script from "./KeytRename.vue?vue&type=script&lang=js"
export * from "./KeytRename.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__